import { render, staticRenderFns } from "./stuChange.vue?vue&type=template&id=73957644&scoped=true"
import script from "./stuChange.vue?vue&type=script&lang=js"
export * from "./stuChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73957644",
  null
  
)

export default component.exports